import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { CashEntryService } from '../../services/CashEntryService';
import * as BullCache from "../../util/BullCache";
import NumberFormatter from "../components/NumberFormatter";
import { NumberToWordFormatter } from "../components/NumberToWordFormatter";

function Cashentry() {
    
    const [admin, setAdmin] = useState([]);
    const [master, setMaster] = useState([]);
    const [broker, setBroker] = useState([]);
    const [client, setClient] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedBroker, setSelectedBroker] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);  
    const [selectedAmount, setSelectedAmount] = useState('');
    const [selectedRemark, setSelectedRemark] = useState('');
    const [transactionType, setTransactionType] = useState('DEPOSIT'); 
    const [balance, setBalance] = useState(0); 

    var user = BullCache.getFromCache("user");

    useEffect(() => {
        if (!user.adminId) return;

        CashEntryService.getAll({ 'adminId': user.adminId }).then(res => {
            if (res.code === 1) {
                if (res.data.adminList.length > 0) {
                    setAdmin(res.data.adminList);
                }
                if (res.data.masterList.length > 0) {
                    setMaster(res.data.masterList);
                }
                if (res.data.brokerList.length > 0) {
                    setBroker(res.data.brokerList);
                }
            }
        });

        CashEntryService.getUsers({ 'adminId': user.adminId }).then(res => {
            if (res.code === 1) {
                if (res.data.userList.length > 0) {
                    setClient(res.data.userList);
                }
            }
        });
    }, [user.adminId]);

    const handleRoleChange = (selectedOption) => {
        setSelectedRole(selectedOption ? selectedOption.value : ''); 
        setSelectedBroker('');  
        setBalance(0);
    };
    const handleBrokerChange = (selectedOption) => {
        setSelectedBroker(selectedOption);  
  
        let matchedAdmin = null;
        if (selectedRole === 'admin') {
             matchedAdmin = admin.find(a => a.adminId === selectedOption.value);
        }
        if (selectedRole === 'master') {
             matchedAdmin = master.find(a => a.adminId === selectedOption.value);
        }
        if (selectedRole === 'broker') {
             matchedAdmin = broker.find(a => a.adminId === selectedOption.value);
        }
        if (selectedRole === 'client') {
            matchedAdmin = client.find(a => a.userid === selectedOption.value);
       }
       
        setBalance(matchedAdmin ? matchedAdmin.balance : 0);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleAmountChange = (e) => {
        setSelectedAmount(e.target.value);
    };

    const handleRemarkChange = (e) => {
        setSelectedRemark(e.target.value);
    };

    const handleTransactionTypeChange = (e) => {
        setTransactionType(e.target.value);
    };


    const getRoleOptions = () => {
        const adminType = user.adminType;
        switch (adminType) {
            case 'SUPER_ADMIN':
            case 'SUPER_MASTER':
                return [
                    { value: 'admin', label: 'ADMIN' },
                    { value: 'master', label: 'MASTER' },
                    { value: 'broker', label: 'BROKER' },
                    { value: 'client', label: 'CLIENT' },
                ];
            case 'ADMIN':
                return [
                    { value: 'master', label: 'MASTER' },
                    { value: 'broker', label: 'BROKER' },
                    { value: 'client', label: 'CLIENT' },
                ];
            case 'MASTER':
                return [
                    { value: 'broker', label: 'BROKER' },
                    { value: 'client', label: 'CLIENT' },
                ];
            case 'SUBBROKER':
                return [
                    { value: 'client', label: 'CLIENT' },
                ];
            default:
                return [];
        }
    };

    const paymentEntry = () => {

        if (!selectedRole || !selectedBroker || !selectedAmount || !selectedDate || parseFloat(selectedAmount) <= 0) {
            Swal.fire({
                icon: "warning",
                text: "Please fill all required fields ",
            });
            return;
        }

        const idToUse = selectedBroker.value;  

        const payment = {
            [selectedRole === 'client' ? 'userId' : 'adminId']: idToUse,  
            transactionType: transactionType,
            paymentType: 'CASH',
            amount: selectedAmount,
            createdDate: selectedDate,
            remark: selectedRemark
        };

        CashEntryService.getPaymententry(payment).then(resp => {
            if (resp.code === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Success!!.."
                });
                // setSelectedRole('');
                // setSelectedBroker('');
                // setSelectedDate(new Date().toISOString().split('T')[0]);  
                 setSelectedAmount('');
                 if(transactionType == 'DEPOSIT') {
                    setBalance(Number(balance) + Number(selectedAmount));
                 } else {
                    setBalance(Number(balance) - Number(selectedAmount));
                 }
                
                 setSelectedRemark('');
                // setTransactionType('DEPOSIT');  

                    if(selectedRole !== 'client') {
                        CashEntryService.getAll({ 'adminId': user.adminId }).then(res => {
                            if (res.code === 1) {
                                if (res.data.adminList.length > 0) {
                                    setAdmin(res.data.adminList);
                                }
                                if (res.data.masterList.length > 0) {
                                    setMaster(res.data.masterList);
                                }
                                if (res.data.brokerList.length > 0) {
                                    setBroker(res.data.brokerList);
                                }
                            }
                        });
                    } else {
                        CashEntryService.getUsers({ 'adminId': user.adminId }).then(res => {
                            if (res.code === 1) {
                                if (res.data.userList.length > 0) {
                                    setClient(res.data.userList);
                                }
                            }
                        });
                    }
                    
            } else {
                Swal.fire({
                    icon: "error",
                    text: resp.messages || "Something Went to Wrong!",
                });
            }
        });
    };


    const clearFields = () => {
        setSelectedRole('');
        setSelectedBroker('');
        setSelectedDate(new Date().toISOString().split('T')[0]);  
        setSelectedAmount('');
        setSelectedRemark('');
        setTransactionType('DEPOSIT'); 
    };

    return (
        <Card className="mt-2 mb-5">
            <Card.Body className='mb-3'>
                <Row>
                    <Col sm={2}>
                        <b className="fss-08">USER TYPE <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>
                    <Col sm={4}>
                        <Select
                            options={getRoleOptions()}
                            className='text-black'
                            onChange={handleRoleChange}
                            value={selectedRole ? { value: selectedRole, label: selectedRole.toUpperCase() } : null}
                            placeholder="Select Role"
                            isClearable
                        />
                    </Col>
                </Row>


                <Row className="mt-3">
                    <Col sm={2}>
                        <b className="fss-08">SELECT <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>
                    <Col sm={4}>
                        <Select
                            options={selectedRole === 'admin'
                                ? admin.map(a => ({ value: a.adminId, label: `${a.firstName} (${a.userName})` }))
                                :  selectedRole === 'master'
                                ? master.map(m => ({ value: m.adminId, label: `${m.firstName} (${m.userName})` }))
                                : selectedRole === 'broker'
                                    ? broker.map(b => ({ value: b.adminId, label: `${b.firstName} (${b.userName})` }))
                                    : selectedRole === 'client'
                                        ? client.map(c => ({ value: c.userid, label: `${c.firstName} (${c.userName})` }))
                                        : []
                            }
                            className='text-black'
                            onChange={handleBrokerChange}
                            value={selectedBroker ? { value: selectedBroker.value, label: selectedBroker.label} : null} 
                            placeholder="Select"
                            isClearable
                            isDisabled={!selectedRole} 
                        />
                    </Col>
                    <Col sm={2} className='mt-2'><NumberFormatter number={balance} /></Col>
                  
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08'>DATE <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <input type="date" size="lg" className='bg-light text-black form-control' value={selectedDate}
                            onChange={handleDateChange} defaultValue={new Date().toISOString().split('T')[0]}
                        />

                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08'> TRANSACTION TYPE</b>
                    </Col>

                    <Col sm={4}>

                        {['radio'].map((type) => (
                            <div key={`inline-${type}`} className="mb-3 border form-control">
                                <Form.Check
                                    inline
                                    label="RECEIPT"
                                    defaultChecked=" "
                                    className='  fss-08'
                                    name="group1"
                                    type={type}
                                    id={`inline-${type}-1`}
                                    checked={transactionType === "DEPOSIT"}
                                    onChange={handleTransactionTypeChange}
                                    value="DEPOSIT"
                                />
                                <Form.Check
                                    inline
                                    label="PAYMENT"
                                    className='  fss-08'
                                    name="group1"
                                    type={type}
                                    id={`inline-${type}-1`}
                                    checked={transactionType === "WITHDRAW"}
                                    onChange={handleTransactionTypeChange}
                                    value="WITHDRAW"
                                />

                            </div>
                        ))}
                    </Col>
                </Row>


                <Row className=''>
                    <Col sm={2}>
                        <b className=' fss-08'>AMOUNT <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <input type='number' className='bg-light text-black form-control' value={selectedAmount}
                            onChange={handleAmountChange} />
                            {selectedAmount ? (
                                                              <label className="word-color">
                                                                {" "}
                                                                {NumberToWordFormatter.numberToWordsIndian(
                                                                  parseInt(selectedAmount, 10)
                                                                )}{" "}
                                                              </label>
                                                            ) : (
                                                              ""
                                                            )}
                    </Col>
                </Row>


                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08' >REMARKS</b>
                    </Col>

                    <Col sm={4}>
                        <input type="text" className="form-control bg-light text-black" id="exampleFormControlInput1"
                            value={selectedRemark}
                            onChange={handleRemarkChange} />
                    </Col>
                </Row>

                <Row className='mt-2'>
                    <Col sm={2}></Col>
                    <Col sm={4}>
                        <Button variant="success" className='me-2 w-25' onClick={paymentEntry}>Save</Button>
                        <Button variant="danger" className='w-25' onClick={clearFields}>Clear</Button>
                    </Col>
                </Row>



            </Card.Body>
        </Card>


    );
}
export default Cashentry;